"use client";

import { c as _c } from "react/compiler-runtime";
import dynamic from "next/dynamic";
import { useEffect } from "react";
import { ErrorBoundary } from "react-error-boundary";
import { useQuery } from "react-query";
import { USER_QUERY_KEY, type User } from "@/components/AuthProvider";
import { applyPerfDebugQueryParam, canUsePerfDebug, usePerfDebugEnabled } from "@/lib/perfDebugMode";
const PerfDebugOverlay = dynamic(() => import("./PerfDebugOverlay"), {
  ssr: false
});
export function PerfDebugMount() {
  const $ = _c(7);
  const enabled = usePerfDebugEnabled();
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      enabled: false,
      staleTime: Number.POSITIVE_INFINITY
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const {
    data: user
  } = useQuery(USER_QUERY_KEY, t0);
  let t1;
  if ($[1] !== user) {
    t1 = canUsePerfDebug(user);
    $[1] = user;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const allowed = t1;
  let t2;
  let t3;
  if ($[3] !== allowed) {
    t2 = () => {
      if (allowed) {
        applyPerfDebugQueryParam(window.location.search);
      }
    };
    t3 = [allowed];
    $[3] = allowed;
    $[4] = t2;
    $[5] = t3;
  } else {
    t2 = $[4];
    t3 = $[5];
  }
  useEffect(t2, t3);
  if (!enabled || !allowed) {
    return null;
  }
  let t4;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <ErrorBoundary fallback={null}><PerfDebugOverlay /></ErrorBoundary>;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  return t4;
}